import React from 'react';
import $i18n from '../../../../i18n';
import './index.less';

const Empty = () => {
  return (
    <div className="smart-studio-empty-content">
      <img src="https://gw.alicdn.com/imgextra/i2/O1CN011Hf7SU1EBrNfuNCZK_!!6000000000314-2-tps-544-408.png" />
      <span>
        {$i18n.get({
          id: 'aopf.monitoringDashboard.graphicComponent.NoDataAvailable',
          dm: '暂无数据',
        })}
      </span>
    </div>
  );
};

export default Empty;
